<div
  class="visual-builder-block"
  [class.selected]="selectedId?.id?.includes('orderItemCard')"
  (click)="selectItemBlock('orderItemCard', $event)"
>
  <a
    class="item-link"
    *ngIf="item?.productUrl; else orderItem"
    [href]="item.productUrl"
    target="_blank"
  >
    <ng-container *ngTemplateOutlet="orderItem"></ng-container>
  </a>
  <ng-template #orderItem>
    <div
      [ngStyle]="{
        boxShadow: itemCard?.shadow,
        backgroundColor: itemCard?.backgroundColor,
        borderColor: itemCard?.borderColor,
        'borderWidth.px': itemCard?.borderWidth,
        'borderRadius.px': itemCard?.borderRadius
      }"
      class="order-item-card"
    >
      <div class="image-container">
        <img [src]="item.imageUrl | productImage" width="60" height="60" />
      </div>
      <div class="product-info">
        <div class="product-title-container">
          <div
            class="visual-builder-block"
            [class.selected]="selectedId?.id?.includes('orderItemTitle')"
            (click)="selectItemBlock('orderItemTitle', $event)"
          >
            <p
              class="product-title"
              [ngStyle]="itemCard?.title | fontFamily | assign : titleStyles"
            >
              {{ item.name }}
            </p>
          </div>
        </div>
        <div
          class="visual-builder-block"
          [class.selected]="selectedId?.id?.includes('orderItemInfo')"
          (click)="selectItemBlock('orderItemInfo', $event)"
        >
          <div
            class="product-attributes"
            [ngStyle]="itemCard?.info | fontFamily | assign : infoStyles"
          >
            <span>Price: {{ item.price }} </span>
            <span>Qty: {{ item.qty }} </span>
            <ng-container *ngIf="itemCard?.showAttributes">
              <span *ngFor="let attribute of item.attributes | keyvalue">
                {{ attribute.key }}: {{ attribute.value }}
              </span>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
  </ng-template>
</div>
